<template>
    <div class="col-md-6">
        <div class="list-group mb-3">
            <div class="list-group-item list-group-item-info">
                {{ $t('breakdown.payout.cardTitle') }}
            </div>
            <div class="list-group-item">
                <strong>{{ calculator.totals.agencyPayoutMarkup | formatMoney(carPackage.currency) }}</strong>
                {{ $t('breakdown.payout.markup') }}
            </div>
            <!--<div class="list-group-item">-->
                <!--<strong>{{ $t('breakdown.header.commissionTbd') }}</strong>-->
                <!--{{ $t('breakdown.payout.commission') }}-->
            <!--</div>-->
            <div class="list-group-item list-group-item-secondary">
                <strong>{{ calculator.totals.totalAgencyPayout | formatMoney(carPackage.currency) }}</strong>
                {{ $t('breakdown.payout.total') }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'price-breakdown-payouts',
        props: ['carPackage', 'calculator']
    };
</script>

<style scoped>

</style>